<template>
  <v-container grid-list-md>
    <v-layout row justify-center>
      <v-flex xs12 md8>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-inner-icon="mdi-format-title"
                    v-model="evento.titulo"
                    label="Título"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="evento.idTurmas"
                    :disabled="turmas.length < 1 || evento.id != null"
                    :items="turmas"
                    label="Turma"
                    :item-text="
                      turma =>
                        `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                    "
                    multiple
                    chips
                    item-value="id"
                    hint="Seleciona a(s) Turma(s)"
                    persistent-hint
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>

                <v-flex xs12 md6>
                  <v-menu
                    v-model="menuDataInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          evento.data_inicio &&
                            moment(evento.data_inicio).format('DD/MM/YYYY')
                        "
                        label="Data Início"
                        prepend-inner-icon="mdi-calendar-today"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="evento.data_inicio"
                      no-title
                      @input="menuDataInicio = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                    class="text-md-center texr"
                    v-model="menuDataFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          evento.data_fim &&
                            moment(evento.data_fim).format('DD/MM/YYYY')
                        "
                        label="Data Término"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="evento.data_fim"
                      no-title
                      @input="menuDataFim = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                    ref="inicio"
                    v-model="menuHoraInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="evento.horario_inicio"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="evento.horario_inicio"
                        label="Hora Inicial"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menuHoraInicio"
                      v-model="evento.horario_inicio"
                      width="290"
                      format="24hr"
                      @click:minute="$refs.inicio.save(evento.horario_inicio)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md6>
                  <v-menu
                    ref="fim"
                    v-model="menuHoraFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="evento.horario_fim"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="evento.horario_fim"
                        label="Hora Final"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menuHoraFim"
                      v-model="evento.horario_fim"
                      width="290"
                      format="24hr"
                      @click:minute="$refs.fim.save(evento.horario_fim)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evento.local"
                    label="Local"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p class="title primary--text">Notificar para</p>
                  <v-radio-group
                    row
                    v-model="evento.enviar"
                    required
                    :rules="rules"
                  >
                    <v-radio
                      v-for="(option, index) in radioOptions"
                      :key="option"
                      color="primary"
                      :label="option"
                      :value="String(index)"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-row>
                    <v-col>
                      <p class="title primary--text">Descrição do evento</p>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn
                        elevation="0"
                        color="primary"
                        @click="$refs.upload.click()"
                      >
                        <v-icon class="mr-3">mdi-paperclip</v-icon>Anexar
                        Arquivo
                      </v-btn>
                      <input
                        type="file"
                        ref="upload"
                        multiple
                        v-show="false"
                        @change="handleUpload"
                      />
                    </v-col>
                    <v-col class="text-left">
                      <v-btn color="primary" @click="$refs.uploadPhoto.click()">
                        <v-icon class="mr-3">mdi-camera</v-icon>Enviar Capa
                      </v-btn>
                      <input
                        type="file"
                        ref="uploadPhoto"
                        v-show="false"
                        @change="handlerPhoto()"
                      />
                    </v-col>
                  </v-row>
                  <wysiwyg ref="descricao" v-model="evento.descricao" />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                elevation="0"
                color="primary"
                dark
                @click="submit"
                :loading="btnLoading"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
    <!-- snakbar -->
    <v-snackbar
      v-model="snack.hide"
      bottom
      :color="snack.color"
      :timeout="snack.imeout"
      multi-line
      >{{ this.snack.mensage }}</v-snackbar
    >
  </v-container>
</template>

<script>
import { Turma, Evento } from '../../service'

export default {
  data() {
    return {
      btnLoading: false,
      evento: {
        status: 'C',
        funcao_id: 1,
        idTurmas: null
      },
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      radioOptions: ['Aluno', 'Responsavel', 'Ambos'],
      turmas: [],
      menuDataInicio: false,
      menuDataFim: false,
      hora_inicio: null,
      hora_fim: null,
      menuHoraInicio: false,
      menuHoraFim: false,
      file: '',
      snack: {},
      capa: '',
      valid: true,
      rules: [v => !!v || 'Campo requerido.']
    }
  },

  async created() {
    await this.load()
  },
  methods: {
    async submit() {
      if (await this.$refs.form.validate()) {
        if (this.evento.descricao) {
          try {
            this.btnLoading = true
            const response = await Evento.save(this.evento, {
              escola: this.escola
            })
            await Evento.setAnexos(response.id, this.file, this.escola)
            await Evento.setCapa(response.id, this.capa, this.escola)
            this.btnLoading = false
            this.snack = {
              mensage: 'Evento cadastrado com sucesso!',
              icon: 'far fa-check-circle',
              hide: true,
              timeout: 3000
            }
            this.$router.push(`/eventos/${response.id}`)
          } catch (error) {
            this.btnLoading = false
            this.snack = {
              color: 'error',
              mensage: 'Falha ao salvar comunicado: ' + error,
              icon: 'fas fa-exclamation-triangle',
              hide: true,
              timeout: 2000
            }
          }
        } else {
          this.snack = {
            mensage: 'O campo descrição também é obrigatório.',
            icon: 'far fa-check-circle',
            hide: true,
            timeout: 3000,
            color: 'red'
          }
        }
      }
    },
    handleUpload() {
      this.file = this.$refs.upload.files
    },
    AllTurma() {
      this.$nextTick(() => {
        if (this.todasTurmas) {
          this.evento.idTurmas = []
        } else {
          this.evento.idTurmas = this.turmas.map(t => t.id) //(this.turmas) (turma) => `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
        }
      })
    },
    removeChip(item) {
      this.evento.idTurmas.splice(this.evento.idTurmas.indexOf(item), 1)
      this.evento.idTurmas = [...this.evento.idTurmas]
    },
    handlerPhoto() {
      this.capa = this.$refs.uploadPhoto.files[0]
    },
    async load() {
      this.turmas = await Turma.findAll({ escola: this.escola })
      if (this.$route.params.id) {
        const evento = await Evento.findById(this.$route.params.id, {
          escola: this.escola
        })
        this.evento = evento
        this.evento.idTurmas = evento.turma.map(t => t.id)
      }
    }
  },
  computed: {
    todasTurmas() {
      return this.evento.idTurmas.length === this.turmas.length
    },
    turmasSelecionadas() {
      return this.evento.idTurmas.length > 0 && !this.todasTurmas
    },
    icon() {
      if (this.todasTurmas) return 'fas fa-times'
      if (this.turmasSelecionadas) return 'far fa-minus-square'
      return 'far fa-square'
    }
  }
}
</script>

<style></style>
